<div class="material-datatables">
  <table id="{{id}}" *ngIf="id == 'contactPartyPickup'" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
      <thead>
        <tr>
          <th>{{ tableContactPartyPickup.headerRow[0] }}</th>
          <th>{{ tableContactPartyPickup.headerRow[1] }}</th>
          <th>{{ tableContactPartyPickup.headerRow[2] }}</th>
          <th class="disabled-sorting text-right">{{ tableContactPartyPickup.headerRow[3] }}</th>
        </tr>
    </thead>
    <tfoot>
      <tr>
        <th>{{ tableContactPartyPickup.footerRow[0] }}</th>
        <th>{{ tableContactPartyPickup.footerRow[1] }}</th>
        <th>{{ tableContactPartyPickup.footerRow[2] }}</th>
        <th class="text-right">{{ tableContactPartyPickup.footerRow[3] }}</th>
      </tr>
    </tfoot>
    <tbody>
      <tr *ngFor="let row of tableContactPartyPickup.dataRows">
        <td>{{row.name}}</td>
        <td>{{row.email}}</td>
        <td>{{row.phone}}</td>
        <td class="text-right">
          <a class="btn btn-link btn-info btn-just-icon accion" (click)="saveEmit('showContactParty',row.id, row)"><i class="material-icons" >remove_red_eye</i></a>
          <a class="btn btn-link btn-success btn-just-icon accion" (click)="saveEmit('editContactParty',row.id, row)"><i class="material-icons" >edit</i></a>
          <a class="btn btn-link btn-danger btn-just-icon accion" (click)="saveEmit('deleteContactParty',row.id, row)"><i class="material-icons">close</i></a>
        </td>
    </tr>
    </tbody>
  </table>
</div>